import React from 'react';
import { Redirect } from 'react-router';
import { getVenues_user, getVenues_user_venues } from './__queries__';
import { useLogger } from '~Hooks';

interface Props {
  user: getVenues_user;
  venues: getVenues_user_venues[];
}

const AutoForwarder: React.FunctionComponent<Props> = ({ venues, user }) => {
  const logger = useLogger('venues-selection');

  if (venues.length === 1) {
    logger.info(`Auto-forwarding to the only venue available: ${venues[0].id}`, {
      userData: user,
    });
    return <Redirect to={`venue/${venues[0].id}/gateway`} />;
  }

  return null;
};

export default AutoForwarder;
